(function($) {

	$(document).ready(function() {
		var menu = document.querySelector('#wrapper-navbar');
		var bmBtn = document.querySelector('.navbar-toggler');
		var html = document.querySelector('html');
		var menuPrevent = document.querySelector('.menu-prevent');
		var mainBackground = document.querySelector('.main-background');
		var allPrevent = document.querySelectorAll('.menu-prevent');
		var isMobileView = false;

		if (bmBtn) {
			bmBtn.addEventListener('click', function() {
				menu.classList.toggle('mb-menu-active');
				html.classList.toggle('no-scroll');

				if (mainBackground) {
					var whiteLogo = mainBackground.querySelector('.logo');
					var menuLogo = mainBackground.querySelector('.mobile-menu-logo');

					whiteLogo.classList.toggle('d-none');
					menuLogo.classList.toggle('d-none');
				}

				if (menuPrevent) {
					if (menuPrevent.classList.contains('first-click')) {
						menuPrevent.classList.remove('mega-toggle-on');
						menuPrevent.classList.remove('first-click');
					}
				}
			});
		}

		function setScreenWidthFlag() {
			if ( $(window).width() > 768) {
				isMobileView = false;
			}
			else {
				isMobileView = true;
			}
		}

		setScreenWidthFlag();


		if (isMobileView) {
			if (menuPrevent) {
				$(allPrevent).each(function() {
					this.addEventListener('click', function(e) {
						e.preventDefault();

						if (this.classList.contains('first-click')) {
							this.classList.remove('mega-toggle-on');
							this.classList.remove('first-click');
						} else {
							if (this.classList.contains('mega-toggle-on')) {
								this.classList.add('first-click');
							}
						}
					});
				});
			}
		}

		$(window).on("resize", function (e) {
			setScreenWidthFlag();

			var win = $(this); //this = window
			if (win.width() >= 768 && html.classList.contains('no-scroll')) {
				bmBtn.click();
			}
		});

		const scrollSlides = document.querySelectorAll('.scroll-func');
		let lastY = window.scrollY;

		if (scrollSlides.length > 0) {
			function scrollSliding() {
				const viewportCenter = window.innerHeight / 2;

				document.body.addEventListener('wheel', function (e) {
					const scrollingDown = window.scrollY > lastY;
					lastY = window.scrollY;

					scrollSlides.forEach(scroll => {
						const rect = scroll.getBoundingClientRect();
						const elementCenter = rect.top + rect.height / 2;
						const band = rect.height * 0.5;

						const isCentered = Math.abs(elementCenter - viewportCenter) < band;

						if (isCentered) {
							const maxScrollLeft = scroll.scrollWidth - scroll.clientWidth;
							const delta = e.deltaY;

							scroll.scrollLeft += delta / 2;

							if (!scroll.classList.contains('scroll-stop')) {
								if (scroll.scrollLeft > 0 && scroll.scrollLeft !== maxScrollLeft) {
									html.classList.add('no-scroll-nh');
								} else {
									html.classList.remove('no-scroll-nh');
									scroll.classList.add('scroll-stop');
								}
							}
						} else {
							// Only reset when scrolling UP past the block
							if (!scrollingDown && rect.top > viewportCenter) {
								scroll.classList.remove('scroll-stop');
								scroll.scrollTo({
									left: 0,
									behavior: "smooth"
								});
							} else {
								// Do nothing when scrolling down
							}
						}
					});
				}, { passive: false });
			}

			if (!isMobileView) {
				scrollSliding();

				$(window).on("resize", function () {
					scrollSliding();
				});
			}
		}

	})

})(jQuery);
